import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true, // trueでLocalStorageに保存（デフォルト）
    autoRefreshToken: true, // トークンの自動更新を有効化
    detectSessionInUrl: true // メール認証後のリダイレクト時などにURLからセッションを検出
  }
})

// データベース型定義
export interface Database {
  public: {
    Tables: {
      users: {
        Row: {
          id: string
          name: string
          phone: string
          password: string
          profile_photo: string | null
          company_name: string | null
          business_content: string | null
          theme: string
          theme_start_date: string
          likes: number
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          name: string
          phone: string
          password: string
          profile_photo?: string | null
          company_name?: string | null
          business_content?: string | null
          theme: string
          theme_start_date: string
          likes?: number
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          name?: string
          phone?: string
          password?: string
          profile_photo?: string | null
          company_name?: string | null
          business_content?: string | null
          theme?: string
          theme_start_date?: string
          likes?: number
          created_at?: string
          updated_at?: string
        }
      }
      stamps: {
        Row: {
          id: string
          user_id: string
          stamp_date: string
          created_at: string
        }
        Insert: {
          id?: string
          user_id: string
          stamp_date: string
          created_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          stamp_date?: string
          created_at?: string
        }
      }
      user_likes: {
        Row: {
          id: string
          liker_user_id: string
          liked_user_id: string
          theme_start_date: string
          created_at: string
        }
        Insert: {
          id?: string
          liker_user_id: string
          liked_user_id: string
          theme_start_date: string
          created_at?: string
        }
        Update: {
          id?: string
          liker_user_id?: string
          liked_user_id?: string
          theme_start_date?: string
          created_at?: string
        }
      }
    }
  }
}